require('./contractDropdownDeposit.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const classnames = require('classnames');
const { formatInterest } = require('utilities/currencyHelper');
const { recordLinkV2 } = require('utilities/tagging');
const { getDepositProduct, getMainDepositCategory } = require('utilities/taggingDeposits');
const { cloneDeep } = require('lodash');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { DepositSelectorItem } = require('components/deposits/depositSelectorItem/depositSelectorItem.js');
// @ constants
const { DEPOSIT_CHOICE, DEPOSIT_SINGLE_CHOICE } = require('constants/tagging');
const { COUNTRIES_CODES: { NL, PT } } = require('constants/countries');
const notDisplayTAECountries = [NL,PT]
import { CATEGORYDICTIONARY, RETENTION_CATEGORY, ORDER } from './constants/constants.js';
import { getCategory } from './helper/index.js';
const {
    CONTRACT_INDEX_DEPOSIT_NEW_MONEY,
} = require('constants/index');

class ContractDropdownDeposit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountsIndexes: []
        };
        this.handleChange = this.handleChange.bind(this);
    }

    fireSelectionTagging(chosenDeposit, immContract, isSingleDeposit, isExclusiveOffer) {
        const customData = ({
            categoriaEvento: getMainDepositCategory(chosenDeposit.type, chosenDeposit.subtype, chosenDeposit.standard, immContract.get('visibleStep')),
            accionEvento: isSingleDeposit ? DEPOSIT_SINGLE_CHOICE : DEPOSIT_CHOICE,
            etiquetaEvento: `${chosenDeposit.depositConfig.months} meses${isExclusiveOffer ? ' exclusiva CC' : ''}`,
            nombreProducto: getDepositProduct(chosenDeposit.type, chosenDeposit.subtype, chosenDeposit.standard)
        });
        recordLinkV2(customData);   
    }

    handleChange(deposit, isSingleDeposit, isExclusiveOffer) {
        const {
            immContract,
            localState,
            actions: {
                refreshFunction,
                termsAndCondsLegalWindowSetParams,
                updateCardDetails,
                updateConfirmationCheckboxes,
                updateDepositProduct,
            },
        } = this.props;
        const { card_details, deposit_product, confirmationCheckboxes } = localState;
        const mainDeposits = immContract.get('mainDeposits');
        const chosenDeposit = mainDeposits.get('data').toJS().find(x => x.depositIdentify === deposit.value);
        
        card_details.find(x => x.id === 'tin').value = chosenDeposit.depositConfig.tin;
        card_details.find(x => x.id === 'tae').value = chosenDeposit.depositConfig.tae;
        card_details.find(x => x.id === 'installment').value = 'contractsView-installmentValueKey';
        card_details.find(x => x.id === 'installment').injectedStringValues = [chosenDeposit.depositConfig.months]
        
        deposit_product.preContractualAlias = chosenDeposit.precontractualProcessType;
        deposit_product.contractualAlias = chosenDeposit.contractualProcessType;
        deposit_product.type = chosenDeposit.type;
        deposit_product.tin = chosenDeposit.depositConfig.tin;
        deposit_product.tae = chosenDeposit.depositConfig.tae;
        deposit_product.months = chosenDeposit.depositConfig.months;
        deposit_product.subtype = chosenDeposit.subtype;
        deposit_product.standard = chosenDeposit.standard;
        deposit_product.name = chosenDeposit.name;
        deposit_product.startDate = chosenDeposit.depositConfig.pictureStartDate;
        deposit_product.max = chosenDeposit.depositConfig.max;
        deposit_product.min = chosenDeposit.depositConfig.min;
        deposit_product.context = chosenDeposit.context;
        deposit_product.depositIdentify = chosenDeposit.depositIdentify;
        deposit_product.wrapup = chosenDeposit.wrapup; // This should match the api field for the wrapup code
        deposit_product.ccPrecontractualPreviewer = chosenDeposit.ccPrecontractualPreviewer;

        updateConfirmationCheckboxes(confirmationCheckboxes);
        
        updateDepositProduct(deposit_product);
        
        updateCardDetails(card_details);
        
        refreshFunction && refreshFunction();
        
        termsAndCondsLegalWindowSetParams(chosenDeposit.precontractualProcessType, chosenDeposit.contractualProcessType);

        this.fireSelectionTagging(chosenDeposit, immContract, isSingleDeposit, isExclusiveOffer)
    }

    buildOptions(deposits){
        const { originCountry } = this.props;

        return deposits.toJS().map(deposit => {
            const tin = formatInterest(deposit.depositConfig.tin);
            const tae = formatInterest(deposit.depositConfig.tae);
            const depositCategoryCc = deposit.labelCategoryCc;
            const formatedTin = `${tin} ${formatText('contractsView-tin')}`;
            const formatedTae = !notDisplayTAECountries.includes(originCountry) ? `${tae} ${formatText('contractsView-tae')}` : false;
            const formatedMonths = formatText('contractsView-installmentValueKey', [deposit.depositConfig.months]);
            return {
                value: deposit.depositIdentify,
                formatedTin,
                formatedTae,
                formatedMonths,
                depositCategoryCc
            }
        });
    }

    buildBox(item, options, selected, isExclusiveOffer = false) {
        const { immContract } = this.props;

        const className = classnames('col-md-3 deposit-selector-radio-button',
        {
            'deposit-selector-radio-button--alt': isExclusiveOffer,
        });

        if (!options.length > 1) {
            const mainDeposits = immContract.get('mainDeposits');
            const chosenDeposit = mainDeposits.get('data').toJS().find(x => x.depositIdentify === deposit.value);
            this.fireSelectionTagging(chosenDeposit, immContract, true, isExclusiveOffer);
        }

        return (
            <div key={item.value} className={className}>
                <DepositSelectorItem
                    preselected={!(options.length > 1)}
                    card={item}
                    active={(options.length > 1) ? (selected===item.value) : true}
                    onClick={(evt, isSingleDeposit) => this.handleChange(evt, isSingleDeposit, isExclusiveOffer)}
                    isExclusiveOffer={isExclusiveOffer}
                />
            </div>
        );
    }

    buildSingleCombo() {
        const { immContract } = this.props;
        const immDepositProduct = immContract.get('deposit_product');
        const mainDeposits = immContract.get('mainDeposits');
        let content;

        if (mainDeposits.get('isFetching')){
            content = <LoadingSection />;
        } else if (!mainDeposits.get('error')){
            const depositsAllowed = immContract.getIn(['mainDeposits', 'data']);
            const options = !!depositsAllowed && this.buildOptions(depositsAllowed);
            const cmbSelected = immDepositProduct.get('depositIdentify');
            const categories = cloneDeep(CATEGORYDICTIONARY);
            const isDepositNewMoney = CONTRACT_INDEX_DEPOSIT_NEW_MONEY === immContract.get('name_contract')

            const boxList = options.reduce((acc, current)=>{
                const category = current.depositCategoryCc ? getCategory(current.depositCategoryCc, true) : 'default';
                if(current.depositCategoryCc && ORDER.includes(category)){
                acc[category].list = [...acc[category].list ,this.buildBox(current, options, cmbSelected, current.depositCategoryCc === RETENTION_CATEGORY)]
                } else if (isDepositNewMoney || !__CONTACT_CENTER__) {
                    acc.default.list = [...acc.default.list, this.buildBox(current, options, cmbSelected)]
                }
                return acc
            },categories)

            content = ORDER.map((item)=>{
                const title = boxList[item].title
                return  boxList[item].list.length > 0  ? (
                    <div className="deposit-radio-card-section" key={item}>
                        {title && <h5 className="deposit-radio-card-section__subtitle">{formatText(title)}</h5>}
                        <div className="deposit-radio-card-section__container">
                            {boxList[item].list}
                        </div>
                    </div>
                ) : null
            })
            return content;
        }
    }

    render() {
        return (             
            <div className="contract-input">
                <h5 className="deposit-radio-subtitle">{formatText("contractsView-contractsView_chooseDepositTermSubTitle")}</h5>
                {this.buildSingleCombo()}
            </div>
        )
    }
}

ContractDropdownDeposit.defaultProps = {
};

ContractDropdownDeposit.propTypes = {
    contractBuilder: PropTypes.object.isRequired,
    localState: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = ContractDropdownDeposit;
